import axios from "../../config/axiosConfig";
import {
  CREATE_PALLET_ISSUE, DELETE_PALLET_ISSUE,
  GET_PALLET_ISSUE,
  PALLET_ISSUE_REQUEST,
  PALLET_ISSUE_REQUEST_FAILURE,
  UPDATE_PALLET_ISSUE,
  GET_PALLET_ISSUES_PAGE,
  PALLET_ISSUE_REQUEST_SUCCESS,
} from "../types/pallet-issue-types";

export const getValidatedIncrementedVchNoPalletIssue = (currentVchNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      
      const response = await axios.get("/pallet-issue/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getPalletIssuesWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PALLET_ISSUE_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Account_Id,Purchase_Account_Id'
      };
      return axios.get("/pallet-issue/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PALLET_ISSUES_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PALLET_ISSUE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PALLET_ISSUE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getPalletIssueById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PALLET_ISSUE_REQUEST });
    
      return axios.get(`/pallet-issue/get/${id}`).then((response) => {
        dispatch({ type: PALLET_ISSUE_REQUEST_SUCCESS });
        return response?.data?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PALLET_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PALLET_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getPalletIssueBeamDetail = (beamNo) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PALLET_ISSUE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, Beam_No: beamNo };
      return axios.get(`/pallet-issue/getBeamDetail`, { params }).then((response) => {
        dispatch({ type: PALLET_ISSUE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PALLET_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PALLET_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getPalletIssuesByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/pallet-issue/getAll", { params });
      return response?.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getPalletIssue = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PALLET_ISSUE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/pallet-issue/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PALLET_ISSUE, payload: response?.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PALLET_ISSUE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PALLET_ISSUE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createPalletIssue = (palletIssue) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: PALLET_ISSUE_REQUEST });
      const newPalletIssue = {
        ...palletIssue
      };
      return axios.post("/pallet-issue/add", newPalletIssue,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_PALLET_ISSUE, payload: response.data });
        } else {
          dispatch({
            type: PALLET_ISSUE_REQUEST_FAILURE,
            error: "Job Yarn Issue create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PALLET_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PALLET_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updatePalletIssue = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PALLET_ISSUE_REQUEST });
      const { auth } = getState();
      return axios.put("/pallet-issue/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_PALLET_ISSUE,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: PALLET_ISSUE_REQUEST_FAILURE,
            error: "Job Yarn Issue update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PALLET_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PALLET_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deletePalletIssue = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PALLET_ISSUE_REQUEST });
      return axios.delete(`/pallet-issue/delete/${id}`).then((response) => {
        if (response.data) {
          const include = ['id', 'Vch_No', 'P_Challan_No', 'Date', 'Narration', 'Account_Id', 'Purchase_Account_Id'].join(',');
          const searchCols = ['Vch_No'].join(',');
          const { currentPage, pageSize, searchStr, where} = getState()?.inventory?.palletIssue || {};
          dispatch(getPalletIssuesWithPagination(currentPage, pageSize, include, searchStr, searchCols, where, true));
          dispatch({ type: DELETE_PALLET_ISSUE, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PALLET_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PALLET_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
